<div class="lvi-content">
    <div class="avatar">
        <i *ngIf="!data.icone" class="nio icon-frais"></i>
        <mat-icon *ngIf="!!data.icone">{{ data.icone }}</mat-icon>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a (click)="onSelect()">{{ data.libelle }}</a>
        </div>
        <ul class="lvi-attrs">
            <li>
                <strong [translate]="'admin.frais.prestations.type'"></strong>
                <span>{{ typePrestation?.libelle }}</span>
            </li>
            <li>
                <strong [translate]="'admin.frais.prestations.remboursable'"></strong>
                <span translate>{{ data.typeRemboursement === TypeRemboursement.REMBOURSABLE ? 'global.oui' : 'global.non' }}</span>
            </li>
            <li *ngIf="typeBareme != null && typeBareme.id != TypeBareme.SANS">
                <strong [translate]="'admin.frais.prestations.bareme'"></strong>
                <span>{{ typeBareme?.libelle }}</span>
            </li>
            <li *ngIf="data.unite != null">
                <strong [translate]="'admin.frais.prestations.unite'"></strong>
                <span>{{ data.unite.libelle }}</span>
            </li>
            <li>
                <strong [translate]="'admin.frais.prestations.code'"></strong>
                <span>{{ data.code }}</span>
            </li>
            <li>
                <strong [translate]="'admin.frais.prestations.compte'"></strong>
                <span>{{ data.compte }}</span>
            </li>
            <li>
                <strong [translate]="'admin.frais.prestations.active'"></strong>
                <span translate>{{ data.actif ? 'admin.frais.prestations.activeOui' : 'admin.frais.prestations.activeNon' }}</span>
            </li>
        </ul>
    </div>
</div>